export default __webpack_public_path__ + "static/media/eduImgWhite.3bf48c9a.svg";